import { useModelBadgeComponent } from "@/configurator/presentation/useModelBadgeComponent";

export function ModelBadge() {
  const { logoSrc, logoAlt } = useModelBadgeComponent();
  if (!logoSrc) return null;

  return (
    <div className="model-badge absolute z-10 flex items-center">
      <img src={logoSrc} alt={logoAlt} className="model-badge__logo w-auto" />
    </div>
  );
}
